const defaultPlayerPage = `
<anvil style="display: none">[{"type":"layout-page-component","classes":["page-container"],"attributes":{},"components":[{"type":"div","name":"Page Wrapper","classes":["page-wrapper"],"components":[{"type":"ignite-player-component","classes":["player-container"],"attributes":{"id":"inferno-video-player"}},{"type":"ignite-qa-component","classes":["qa-container"],"attributes":{"id":"inferno-questions-basic"},"components":[{"name":"QA ","removable":false,"draggable":false,"copyable":false,"classes":["inferno-input-group","qa-forge-required"],"components":[{"name":"QA Input Group","removable":false,"draggable":false,"copyable":false,"classes":["inferno-input-group-addon","qa-forge-required"]},{"tagName":"input","name":"QA Input","removable":false,"draggable":false,"copyable":false,"void":true,"classes":["inferno-form-control","qa-forge-required"],"attributes":{"placeholder":"Ask A Question"}},{"tagName":"span","name":"QA Button Group","removable":false,"draggable":false,"copyable":false,"classes":["inferno-input-group-btn","qa-forge-required"],"components":[{"tagName":"button","name":"QA Input Button","removable":false,"draggable":false,"copyable":false,"classes":["inferno-btn","qa-forge-required"],"components":[{"type":"textnode","content":"Submit"}]}]}]}]}]}]}]</anvil>
<style>* { box-sizing: border-box; } body {margin: 0;}*{box-sizing:border-box;}body{margin-top:0px;margin-right:0px;margin-bottom:0px;margin-left:0px;}.page-container{width:100%;min-height:calc(100vh - 55px);display:flex;justify-content:center;align-content:flex-start;position:absolute;top:0px;right:0px;bottom:0px;left:0px;background-repeat-x:repeat;background-repeat-y:repeat;background-position-x:50%;background-position-y:50%;background-attachment:scroll;background-size:cover;background-image:url("https://inferno-event-assets.s3.us-west-2.amazonaws.com/inspiration/common/assets/bg-alt.png");align-items:flex-start;}.page-wrapper{width:100%;min-height:100%;max-width:1000px;padding-top:1rem;padding-right:1rem;padding-bottom:1rem;padding-left:1rem;display:flex;flex-direction:column;align-items:center;align-content:center;justify-content:center;}.player-container{width:100%;min-height:100px;}.qa-container{width:100%;margin-top:1rem;}.inferno-input-group{display:flex;background-image:initial;background-position-x:initial;background-position-y:initial;background-size:initial;background-repeat-x:initial;background-repeat-y:initial;background-attachment:initial;background-origin:initial;background-clip:initial;background-color:rgb(5, 14, 49);border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:4px;border-bottom-left-radius:4px;padding-top:1rem;padding-right:1rem;padding-bottom:1rem;padding-left:1rem;width:100%;}.inferno-form-control{width:100%;padding-top:0.5rem;padding-right:0.5rem;padding-bottom:0.5rem;padding-left:0.5rem;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:4px;border-bottom-left-radius:4px;margin-right:0.5rem;background-image:initial;background-position-x:initial;background-position-y:initial;background-size:initial;background-repeat-x:initial;background-repeat-y:initial;background-attachment:initial;background-origin:initial;background-clip:initial;background-color:white;border-top-width:initial;border-right-width:initial;border-bottom-width:initial;border-left-width:initial;border-top-style:none;border-right-style:none;border-bottom-style:none;border-left-style:none;border-top-color:initial;border-right-color:initial;border-bottom-color:initial;border-left-color:initial;border-image-source:initial;border-image-slice:initial;border-image-width:initial;border-image-outset:initial;border-image-repeat:initial;outline-color:initial;outline-style:none;outline-width:initial;color:rgb(5, 14, 49);}.inferno-input-group-btn{color:rgb(5, 14, 49);}.inferno-btn{width:100px;height:100%;background-image:initial;background-position-x:initial;background-position-y:initial;background-size:initial;background-repeat-x:initial;background-repeat-y:initial;background-attachment:initial;background-origin:initial;background-clip:initial;background-color:white;color:rgb(5, 14, 49);font-weight:bold;display:flex;justify-content:center;align-items:center;align-content:center;text-align:center;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-width:initial;border-right-width:initial;border-bottom-width:initial;border-left-width:initial;border-top-style:none;border-right-style:none;border-bottom-style:none;border-left-style:none;border-top-color:initial;border-right-color:initial;border-bottom-color:initial;border-left-color:initial;border-image-source:initial;border-image-slice:initial;border-image-width:initial;border-image-outset:initial;border-image-repeat:initial;outline-color:initial;outline-style:none;outline-width:initial;}.inferno-input-group-addon{display:none;}</style>
<div class="page-container"><div class="page-wrapper"><div class="player-container" id="inferno-video-player"></div><div class="qa-container" id="inferno-questions-basic"><div class="inferno-input-group qa-forge-required"><div class="inferno-input-group-addon qa-forge-required"></div><input class="inferno-form-control qa-forge-required" placeholder="Ask A Question"/><span class="inferno-input-group-btn qa-forge-required"><button class="inferno-btn qa-forge-required">Submit</button></span></div></div></div></div>
<script defer async>
  console.log("Starting Snippet Scripts");
  var items = document.querySelectorAll('#inferno-video-player');
    for (var i = 0, len = items.length; i < len; i++) {
      (function(){
const resize = () => {};

    resize();
    let observer = new ResizeObserver(entries => {
      entries.forEach(mutation => {
        resize();
      });
    });
    observer.observe(this);
}.bind(items[i]))();
    }
    var props = {"inferno-questions-basic":{"placeholder":"Ask A Question"}};
    var ids = Object.keys(props).map(function(id) { return '#'+id }).join(',');
    var els = document.querySelectorAll(ids);
    for (var i = 0, len = els.length; i < len; i++) {
      var el = els[i];
      (function (props) {
    let element = this;
    let forms = document.querySelectorAll('.inferno-form-control');

    for (let form of forms) {
      console.log('Setting Placeholder', props.placeholder);
      console.log(form);
      form.setAttribute('placeholder', props.placeholder);
    }

    let iterations = 0;

    let interval = () => setInterval(() => {
      iterations++;

      if (iterations > 1000) {
        clearTimeout(interval);
      }

      let isForge = document.querySelectorAll('[class*=gjs]');

      if (isForge.length === 0) {
        let forgeContainer = element.querySelector('.qa-forge-required');

        try {
          forgeContainer.remove();
        } catch (e) {
          clearTimeout(interval);
        }
      }
    }, 100);

    interval();
  }.bind(el))(props[el.id]);
    }
</script>
<script defer>
  (async () => {
    // Update VXP Tools
    try { window["VXP_Tools"].root = document } catch(e) {}
    try { window["VXP_Tools"].root = landingPageEl } catch(e) {}
    try { window["VXP_Tools"].root = loginPageEl } catch(e) {}

    // Fixes padding issue from IgniteX.
    // Make the container fill the whole page at a minimum.
    $('.content-wrapper').css('padding', '0px');
    $('.content-wrapper').css('min-height', 'calc(100vh - 55px)');

    // Removes IgniteX standard footer on all pages since it doesn't work. 🙄
    $('footer[layout="row"]').attr("style", "display: none !important;");

    // Removes the bottom margin from the section container that was used to show the footer.
    $('.wrapper > section[class="IE-FlexAuto"]').attr('style', 'margin-bottom: 0px !important;');

    // Make the container fill the whole page at a minimum.
    try {
      $(landingPageEl).find("#landing").css('min-height', 'calc(100vh - 55px)');
    } catch (e) {}

    
  try {
    console.log("Fetching Snippets")
    let tools = window['VXP_Tools'];
    fetch(tools.apiUrl+'/Snippets', tools.GET).then(res => res.json()).then(snippets => {
      // console.log("Found snippets");
      for (let snx of snippets) {
        if (snx.name === 'anvil-header') {
          fetch(tools.apiUrl+'/Snippets/LatestRevisionHtml/'+snx.id, tools.GET).then(res => res.text()).then(html => {
            // console.log("Got Header")
            // console.log(html);
            $(tools.root).find('.page-container').prepend($(html));
          })
        }
        if (snx.name === 'anvil-footer') {
          fetch(tools.apiUrl+'/Snippets/LatestRevisionHtml/'+snx.id, tools.GET).then(res => res.text()).then(html => {
            // console.log("Got Footer")
            // console.log(html);
            $(tools.root).find('.page-container').append($(html));
          })
        }
      }
    })
  } catch(e) {
    console.error(e.message);
  }
 

    
  })();
</script>
`

export default defaultPlayerPage;